(function ($, Drupal) {
  Drupal.behaviors.elcaBehavior = {
    attach: function (context, settings) {
      (function () {
        var throttle = function (type, name, obj) {
          obj = obj || window;
          var running = false;
          var func = function () {
            if (running) {
              return;
            }
            running = true;
            requestAnimationFrame(function () {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
            });
          };
          obj.addEventListener(type, func);
        };

        /* init - you can init any event */
        throttle('scroll', 'optimizedScroll');
      })();

      window.addEventListener('optimizedScroll', function () {
        setArrowsVisibility();
        setMenuPosition();
      });

      const scrollmagicSectionController = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 'onLeave'}});
      const scrollmagicController = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onEnter',
          offset: 300,
        }
      });

      const scrollmagicControllerOffset = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onEnter',
          offset: -250,
          duration: '150%'
        }
      });

      var scrollmagicPinnedController = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onLeave',
          duration: '100%'
        }
      });
      $('.pinned').each(function (index, element) {
        let timeline = new TimelineMax();
        timeline.to(element, 0.25,
          {
            'opacity': 0,
            filter: 'blur(25px)',
            autoRound: false
          });

        new ScrollMagic.Scene({triggerElement: element})
          //.setTween(element, {y: '80%', ease: Linear.easeNone})
          .setTween(timeline)
          .setPin(element, {pushFollowers: false})
          .addTo(scrollmagicPinnedController);
      });

      var scrollmagicTweenedController = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onLeave',
          duration: '200%'
        }
      });
      $('.tweened').each(function (index, element) {
        new ScrollMagic.Scene({triggerElement: element})
          .setTween(element, {y: '80%', ease: Linear.easeNone})
          .addTo(scrollmagicTweenedController);
      });

      function navigatePrevSection() {
        const navigator = document.getElementById('sectionNavigator');
        const active = navigator.getElementsByClassName('active')[0];
        if (active) {
          const prev = active.previousElementSibling;
          if (prev.matches('.navigator-item')) {
            const targetEl = document.getElementById(prev.dataset.targetId);
            TweenMax.to(window, 0.5, {
              scrollTo: {
                y: targetEl.offsetTop,
                autoKill: true // allows user to kill scroll action smoothly
              },
              ease: Cubic.easeInOut
            });
          }
        }
        else {
          const items = navigator.getElementsByClassName('navigator-item');
          const lastItem = items.item(items.length - 1);
          const targetEl = document.getElementById(lastItem.dataset.targetId);
          TweenMax.to(window, 0.5, {
            scrollTo: {
              y: targetEl.offsetTop,
              autoKill: true // allows user to kill scroll action smoothly
            },
            ease: Cubic.easeInOut
          });
        }
      }

      function navigateNextSection() {
        const navigator = document.getElementById('sectionNavigator');
        const active = navigator.getElementsByClassName('active')[0];
        if (active) {
          const next = active.nextElementSibling;
          if (next.matches('.navigator-item')) {
            const targetEl = document.getElementById(next.dataset.targetId);
            TweenMax.to(window, 0.5, {
              scrollTo: {
                y: targetEl.offsetTop,
                autoKill: true // allows user to kill scroll action smoothly
              },
              ease: Cubic.easeInOut
            });
          }
        }
      }

      function navigateSection(event) {
        const sectionTarget = event.target.dataset.targetId;
        const targetEl = document.getElementById(sectionTarget);
        TweenMax.to(window, 0.5, {
          scrollTo: {
            y: targetEl.offsetTop,
            autoKill: true // allows user to kill scroll action smoothly
          },
          ease: Cubic.easeInOut
        });
      }

      function setSliderHeight() {
        const jouerEnLigne = $('#jouer-en-ligne');
        const html = document.querySelector('html');
        const isAlert = html.classList.contains('alert') ? true : false;
        if (isAlert) {
          const height = $('.alert-block').height();
          jouerEnLigne.css('height','calc(100vh - ' + height +')');
        }
      }

      function setMenuPosition() {
        const html = document.querySelector('html');
        const isAlert = html.classList.contains('alert') ? true : false;

        if (isAlert) {
          const menu = document.querySelector('.main-menu');
          const navigator = document.getElementById('sectionNavigator');

          menu.style.position = 'relative';
          menu.style.transition = 'position 0ms ease 0s';

          if (menu) {
            if (document.documentElement.scrollTop > 72) {
              menu.style.position = 'fixed';
              menu.style.top = '0';
            } else {
              menu.style.position = 'relative';
              menu.style.removeProperty('top');
            }
          }

          if (navigator) {
            if (document.documentElement.scrollTop > 72) {
              navigator.style.top = '9rem';
            } else {
              navigator.style.top = 'calc(9rem + 72px)';
            }
          }
        }
      }

      function setArrowsVisibility() {
        const navigator = document.getElementById('sectionNavigator');

        if (navigator === null || !navigator.length) {
          return;
        }

        const items = navigator.getElementsByClassName('navigator-item');
        const array = Array.from(items);
        const index = array.findIndex(element => element.matches('.active'));
        const prev = navigator.getElementsByClassName('prev')[0];
        const next = navigator.getElementsByClassName('next')[0];

        switch (true) {
          case (index === 0):
            prev.classList.remove('on');
            next.classList.add('on');
            break;
          case (document.documentElement.scrollTop === 0):
            prev.classList.remove('on');
            next.classList.add('on');
            break;
          case (index > 0 && index < (array.length - 1)):
            prev.classList.add('on');
            next.classList.add('on');
            break;
          case (index === (array.length - 1)):
            prev.classList.add('on');
            next.classList.remove('on');
            break;
          case ((window.innerHeight + document.documentElement.scrollTop) >= document.body.offsetHeight):
            prev.classList.add('on');
            next.classList.remove('on');
            break;
        }
      }

      function getSectionData(sections) {
        let data = [];
        sections.forEach(function (section) {
            data.push({
              id: section.id,
              title: section.dataset.section,
              bgColor: section.dataset.bgColor ? 'taxonomy-colors__bg--' + section.dataset.bgColor : 'taxonomy-colors__bg--transparent-black'
            });
          }
        );
        return data;
      }

      function buildSectionNavigator(sections) {
        const html = document.querySelector('html');
        const navigator = document.createElement('ul');
        navigator.id = 'sectionNavigator';
        document.getElementsByTagName('body')[0].appendChild(navigator);

        const prevItem = document.createElement('li');
        const prevItemSpan = document.createElement('span');
        prevItem.classList.add('navigatorArrow', 'prev');
        prevItem.addEventListener('click', navigatePrevSection);
        prevItem.appendChild(prevItemSpan);
        navigator.appendChild(prevItem);

        const data = getSectionData(sections);

        data.forEach(function (datum) {
          const navigatorItem = document.createElement('li');
          const navigatorItemTitle = document.createElement('span');
          navigatorItemTitle.innerHTML = datum.title;

          navigatorItem.setAttribute('data-target-id', datum.id);
          navigatorItem.setAttribute('data-navigator-item', datum.title);
          navigatorItem.classList.add('navigator-item', datum.bgColor);
          navigatorItem.appendChild(navigatorItemTitle);

          navigatorItem.addEventListener('click', navigateSection);
          navigator.appendChild(navigatorItem);
        });

        const nextItem = document.createElement('li');
        const nextItemSpan = document.createElement('span');
        nextItem.classList.add('navigatorArrow', 'next');
        nextItem.addEventListener('click', navigateNextSection);
        nextItem.appendChild(nextItemSpan);
        navigator.appendChild(nextItem);

        setTimeout(function () {
          setArrowsVisibility();
        }, 0);


        const isAlert = html.classList.contains('alert') ? true : false;
        if (isAlert) {
          navigator.style.top = 'top: calc(9rem + 72px)';
        }

      }


      const homepage2020 = document.querySelector('html.homepage-2020');
      if (homepage2020) {

        let vh = window.innerHeight;

        window.addEventListener('resize', () => {
          // We execute the same script as before
          vh = window.innerHeight;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        const sections = document.querySelectorAll('.section.navigable');
        const sectionItems = document.querySelectorAll('.section__item');
        const videoBackgrounds = document.querySelectorAll('.section__item__video-background');

        buildSectionNavigator(sections);
        setMenuPosition();
        // setSliderHeight();

        sections.forEach(function (sectionItem) {
          const id = $(sectionItem).attr('id');
          const navigatorSection = $('*[data-target-id="' + id + '"]')[0];
          const offsetHeight = $(sectionItem)[0].offsetHeight;
          new ScrollMagic.Scene({
            triggerElement: sectionItem,
            duration: offsetHeight
          })
            .addTo(scrollmagicSectionController)
            .setClassToggle(navigatorSection, 'active')
            .addTo(scrollmagicController);
        });


        sectionItems.forEach(function (sectionItem) {
          new ScrollMagic.Scene({
            triggerElement: sectionItem
          })
            .addTo(scrollmagicController)
            .setClassToggle(sectionItem, 'entered')
            .reverse(false);
        });

        sectionItems.forEach(function (sectionItem) {
          new ScrollMagic.Scene({
            triggerElement: sectionItem,
          })
            .addTo(scrollmagicControllerOffset)
            .on('enter', lazyLoadImage(sectionItem));
        });

        videoBackgrounds.forEach(function (sectionItem) {
          new ScrollMagic.Scene({
            triggerElement: sectionItem,
          })
            .addTo(scrollmagicControllerOffset)
            .setClassToggle(sectionItem, 'offsetIn');
        });
      }


      function lazyLoadImage(sectionItem) {
        const bgImages = sectionItem.querySelectorAll('.bg-image');
        for (const bgImage of bgImages) {
          bgImage.classList.remove('bg-image--lazy');
        }
      }

      let portraitForm = $('#views-exposed-form-portraits-page-1:not(.loro-behavior-processed), #views-exposed-form-portraits-page-2:not(.loro-behavior-processed)', context);
      if (portraitForm.length) {
        let portraitFormSubmit = portraitForm.find('.form-submit');
        let portraitFormFilters = portraitForm.find('label[type=checkbox]');
        portraitFormFilters.on('click', function () {
          setTimeout(function () {
            portraitFormSubmit.click();
          }, 120);
          portraitForm.addClass('loro-behavior-processed');
        });
      }


      let mobileFilterPanel = $('#block-exposedformportraitspage-1, #block-hervorgehobenesformularportraitspage-2');
      if (mobileFilterPanel) {
        let mobileFilterToggler = $('.mobile-filter-toggler', context);
        mobileFilterToggler.on('click', function () {
          $(this).toggleClass('active');
          $('#block-exposedformportraitspage-1').toggleClass('active');
          $('#block-hervorgehobenesformularportraitspage-2').toggleClass('active');
        });
      }


      let modal = $('#modal', context);
      $(window).on('load', function () {
        modal.addClass('active');
        modal.css('z-index', 1000);
      });
      $('a.dismiss-modal', context).on('click', function (e) {
        document.getElementById('modal').classList.remove('active').style.zIndex = '-1';
        e.preventDefault();
      });

      const $viewsExposedFormPortraits = $('#views-exposed-form-portraits-page-1, #views-exposed-form-portraits-page-2');
      if ($viewsExposedFormPortraits.length > 0 && !$viewsExposedFormPortraits.hasClass('behavior-attached')) {

        const $submit = $viewsExposedFormPortraits.find('.form-submit');
        const $searchField = $viewsExposedFormPortraits.find('input[name="field_teaser_description_value"]');
        const $searchFieldReset = $searchField.parent().find('.reset');

        let timeout = null;
        const delay = 300;
        $searchField.keyup(function() {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            $submit.click();
          }, delay);
        });

        $searchFieldReset.click(function() {
          if ($searchField.val().length > 0) {
            $searchField.val('');
            $submit.click();
          }
        });

        $viewsExposedFormPortraits.addClass('behavior-attached');
      }
    }
  }
  ;
})
(jQuery, Drupal);
